module.exports = __webpack_public_path__ + "static/media/galeria_elo_02.2b29c7b8.jpg";